import { CREATE_MANAGEMENT_START } from "../../types";

export const create_management = (payload) => ({
    type: CREATE_MANAGEMENT_START,
    payload,
});
